// extracted by mini-css-extract-plugin
module.exports = {"bg":"e__p","border":"e_0p"};